// recon-loans-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'rcn.docStatus.validForPeriod': 'Válido para el período',
  'rcn.docStatus.carriedForward': 'Arrastrado hasta el cierre del período',
  'rcn.docStatus.needsCarryForward': 'Requiere arrastre',
  'rcn.docStatus.wrongPeriod': 'Período incorrecto',
  'rcn.docStatus.incomplete': 'Documentación incompleta',
  'rcn.docStatus.wrongCompany': 'Empresa incorrecta',
  'rcn.docStatus.missing': 'Falta',
  'rcn.docIssue.none': 'Sin objeciones',
  'rcn.docIssue.wrongCompany': 'Corresponde a otra empresa',
  'rcn.docIssue.incomplete': 'Documentación incompleta',
  'rcn.repaymentType.serial': 'Préstamo de amortización constante — cuotas de capital iguales',
  'rcn.repaymentType.annuity': 'Préstamo de anualidad — cuotas totales iguales',
  'rcn.repaymentType.interestOnly': 'Sin amortización — solo intereses',
  'rcn.repaymentType.unknown': 'Desconocido / otro',
  'rcn.check.unregistered': 'Cuentas de deuda sin préstamo registrado',
  'rcn.check.documentation': 'Préstamos sin documentación válida para el período',
  'rcn.check.plan': 'Préstamos sin plan de amortización',
  'rcn.check.interest': 'Préstamos con intereses devengados sin contabilizar',
  'rcn.check.fees': 'Préstamos con comisiones sin contabilizar',
  'rcn.check.currency': 'Préstamos en moneda extranjera',
  'rcn.check.unclassified': 'Deuda contabilizada fuera de la deuda a corto y largo plazo',
});
